import { useDispatch } from 'react-redux';

import { updateActiveBoxLine, setActiveBox, setActiveBoxProductCount, removeBox, useAddActiveBoxToCart } from '@app/store/rtk.cart.store';
import QuantityInput from '@components/common/helpers/quantity-input';

import { ICartBox } from '@interfaces';
import { usePackBoxIndex } from '@app/store/cart.selectors';

export function PackQuantityInput({ box }: { box: ICartBox }) {
    const dispatch = useDispatch();
    const addActiveBoxToCart = useAddActiveBoxToCart();

    const line = Object.values(box.lines).shift();
    const packBoxIndex = usePackBoxIndex(line.product.id);
    const isMaxed = line && box.blueprint.maxItems <= line.count;

    const setCount = (count: number) => {
        dispatch(setActiveBox({ index: packBoxIndex }));
        dispatch(updateActiveBoxLine({ product: line.product, count }));

        if (count < 1) {
            dispatch(removeBox({ index: packBoxIndex }));
        } else {
            addActiveBoxToCart();
        }
    }

    return (
        <QuantityInput
            count={box.count}
            setCount={setCount}
            title={line.product.title}
            isOutOfStock={line?.product?.status !== 'instock'}
            isMaxed={isMaxed}
            maxedType={isMaxed ? line.product.category : null} />
    );
}

export function VarietyPackQuantityInput({ box }: { box: ICartBox }) {
    const dispatch = useDispatch();
    const addActiveBoxToCart = useAddActiveBoxToCart();
    const count = box.productCount || 0;
    const packBoxIndex = usePackBoxIndex(box.productId);
    const isMaxed = (box.blueprint.maxItems <= box.count);
    const packProducts = box.productBlueprint;

    const setCount = (count: number) => {
        dispatch(setActiveBox({ index: packBoxIndex }));
        dispatch(setActiveBoxProductCount({ count }));

        Object.values(packProducts).forEach((product: any) => {
            dispatch(updateActiveBoxLine({ product: { ...product, categoryMaxItems: 1000 }, count: product.size * count }));
        });

        if (count < 1) {
            dispatch(removeBox({ index: packBoxIndex }));
        } else {
            addActiveBoxToCart();
        }
    }

    return (
        <QuantityInput
            count={count}
            setCount={setCount}
            title={box.title}
            isOutOfStock={false}
            isMaxed={isMaxed}
            maxedType={isMaxed ? 'units' : null} />
    );
}